import * as yup from 'yup';
import { CountrySelectId, requiredErrorMessage } from 'shared/consts';
import { validatePhoneNumber } from 'entities/users/lib/helpers/validatePhoneNumber';

export const validationSchemas = yup.object().shape({
  selectedCountryCode: yup.string().required(requiredErrorMessage),
  phone: yup
    .string()
    .required(requiredErrorMessage)
    .test('phone-validation', 'Неверный номер телефона', function (value) {
      const countryCode = this.resolve(yup.ref('selectedCountryCode')) as string;
      return validatePhoneNumber(countryCode, value);
    }),
  first_name: yup.string().required(requiredErrorMessage),
  city_id: yup.number().test('city_id', requiredErrorMessage, (value) => typeof value === 'number'),
  country_id: yup.number().test('country_id', requiredErrorMessage, (value) => typeof value === 'number'),
  last_name: yup.string().required(requiredErrorMessage),
  middle_name: yup.string(),
  iin: yup.string(),
  passport_number: yup.string(),
  passport_issued_at: yup.string(),
  passport_expiration_at: yup.string(),
  source_id: yup.number(),
  role: yup.number(),
  gender: yup.number(),
  personal_number: yup.string(),
  authority: yup.string(),
});

export const validationSchemaCreateUserData = yup.object().shape({
  phone: yup
    .string()
    .required(requiredErrorMessage)
    .test('phone-validation', 'Неверный номер телефона', (value, { parent }) => {
      const countryCode = parent.selectedCountryCode;
      return validatePhoneNumber(countryCode, value);
    }),
  first_name: yup.string().required(requiredErrorMessage),
  middle_name: yup.string(),
  last_name: yup.string().required(requiredErrorMessage),
  city_id: yup
    .number()
    .nullable()
    .test('city_id', requiredErrorMessage, (value) => typeof value === 'number'),
  country_id: yup
    .number()
    .nullable()
    .test('country_id', requiredErrorMessage, (value) => typeof value === 'number'),
  iin: yup.string().nullable(),
  source_id: yup.number(),
  role: yup.number(),
  selectedCountryCode: yup.string().required(requiredErrorMessage),
  document_number: yup
    .string()
    .test('countryValidation', 'Номер документа должен содержать 2 латинские буквы и 7 цифр', (value, { parent }) => {
      const rule = /^[A-Za-z]{2}\d{7}$/;
      if (parent.country_id === 4 && value) {
        return rule.test(value!);
      }
      if (parent.country_id === 3) {
        return rule.test(value!);
      }
      return true;
    }),
  personal_number: yup
    .string()
    .test('lengthTest', 'Персональный номер должен содержать 14 цифр', (value, { parent }) => {
      if (parent.country_id === 3 || parent.country_id === 4) {
        return value?.length === 14;
      }
      return true;
    }),
  issued_at: yup.string().test('requared', requiredErrorMessage, (value, { parent }) => {
    if (parent.country_id === 3 || parent.country_id === 4) {
      return value?.length !== 0;
    }
    return true;
  }),
  expiration_at: yup.string().test('requared', requiredErrorMessage, (value, { parent }) => {
    if (parent.country_id === 3 || parent.country_id === 4) {
      return value?.length !== 0;
    }
    return true;
  }),
});

export const validationSchemaPersonalData = yup.object().shape({
  first_name: yup.string().required(requiredErrorMessage),
  last_name: yup.string().required(requiredErrorMessage),
  middle_name: yup.string(),
  iin: yup.string().test('required', 'ИИН / ПИН / ПИНФЛ / Номер паспорта обязателен', (value, { parent }) => {
    const { country_id } = parent;

    if (country_id === CountrySelectId.KZ && value) {
      return value?.length > 0;
    }

    return country_id !== CountrySelectId.KZ;
  }),
  city_id: yup.number().required(requiredErrorMessage),
  document_number: yup
    .string()
    .test('validationRule', 'Номер документа должен содержать 2 латинские буквы и 7 цифр', (value, { parent }) => {
      const { country_id } = parent;
      const rule = /^[A-Za-z]{2}\d{7}$/;

      if ((country_id === CountrySelectId.UZ && value?.length! > 0) || (country_id === CountrySelectId.KG && value)) {
        return rule.test(value!);
      }
      return true;
    })
    .test('required', requiredErrorMessage, (value, { parent }) => {
      const { country_id } = parent;

      return (country_id === CountrySelectId.KG && !!value) || country_id !== CountrySelectId.KG;
    }),
  issued_at: yup
    .string()
    .nullable()
    .test('required', requiredErrorMessage, (value, { parent }) => {
      const { country_id } = parent;
      if (country_id === CountrySelectId.KG || country_id === CountrySelectId.UZ) {
        return !!(value && value?.length !== 0);
      }

      return true;
    }),
  expiration_at: yup
    .string()
    .nullable()
    .test('required', requiredErrorMessage, (value, { parent }) => {
      const { country_id } = parent;
      if (country_id === CountrySelectId.KG || country_id === CountrySelectId.UZ) {
        return !!(value && value?.length !== 0);
      }

      return true;
    }),
  personal_number: yup
    .string()
    .nullable()
    .test('lengthTest', 'Персональный номер должен содержать 14 цифр', (value, { parent }) => {
      const { country_id } = parent;
      if (country_id === 3 || country_id === 4) {
        return value?.length === 14;
      }

      return true;
    }),
  country_id: yup.number(),
});

export const validationSchemaUserData = yup.object().shape({
  country_id: yup.number(),
  phone: yup.string().required(requiredErrorMessage),
  user_role_ids: yup.array().required(requiredErrorMessage),
  source_id: yup.number().nullable().required(requiredErrorMessage),
  channel: yup.string(),
  is_b2b: yup.boolean(),
  is_b2cr: yup.boolean(),
  is_b2c: yup.boolean(),
});
